import { convertItemDTOToPopulatedItem } from '../../utils/converters';
import { getDuplicateItemName } from '../../utils/item';
export const getItemsToDuplicate = _ref => {
  let {
    items,
    duplicatedNameCreator
  } = _ref;
  const itemsToDuplicate = items.map(item => {
    const {
      revision,
      ...itemWithoutRevision
    } = item;
    return {
      ...itemWithoutRevision,
      name: getDuplicateItemName(duplicatedNameCreator, item.name)
    };
  });
  return {
    itemsToDuplicate
  };
};
export const buildDuplicatedPopulatedItem = (item, priceVariantsMap, labelsMap, modifierGroupsMap, populationLevel) => {
  var _item$priceVariants, _item$labels, _item$modifierGroups;
  const priceVariants = (_item$priceVariants = item.priceVariants) == null || (_item$priceVariants = _item$priceVariants.variants) == null ? void 0 : _item$priceVariants.map(priceVariant => priceVariantsMap[priceVariant.variantId]);
  const labels = (_item$labels = item.labels) == null ? void 0 : _item$labels.map(label => labelsMap[label.id]);
  const populatedModifierGroups = (_item$modifierGroups = item.modifierGroups) == null ? void 0 : _item$modifierGroups.map(modifierGroup => modifierGroupsMap[modifierGroup.id]);
  const itemInPopulatedForm = convertItemDTOToPopulatedItem(item, populatedModifierGroups, priceVariants, labels, populationLevel);
  return itemInPopulatedForm;
};
//# sourceMappingURL=duplicateItems.utils.js.map